import React from 'react';
import { ChalkboardPattern } from './ChalkboardPattern';
export function ProblemSection() {
  const problems = [{
    emoji: '😰',
    title: 'Creative Burnout',
    text: 'You arrive at the gym exhausted after spending your entire afternoon hunting for drills on YouTube or Instagram, without knowing how to link them into a coherent session.'
  }, {
    emoji: '🏐',
    title: 'Lack of Structure',
    text: 'Your practices feel "clunky." You improvise drills on the fly, and you feel like your players are just "playing" instead of actually progressing.'
  }, {
    emoji: '📱',
    title: 'Information Overload',
    text: "The internet is full of contradictory advice. You don't know which session structure is truly effective for a 90-minute window on a Tuesday night."
  }, {
    emoji: '😩',
    title: 'Massive Mental Load',
    text: 'Managing rosters, club logistics, and season planning prevents you from actually enjoying your passion for volleyball.'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-189">
      <ChalkboardPattern className="text-pilates-blue-dark opacity-[0.02]" data-id="element-190" />
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <div className="border border-pilates-lavender text-pilates-blue-dark font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-193">
            DOES THIS SOUND LIKE YOU?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight mb-5 tracking-tight" data-id="element-194">
            You love coaching, but{' '}
            <span className="italic text-pilates-rose" data-id="element-195">preparation</span> is
            consuming all your free time.
          </h2>
          <p className="text-lg text-pilates-slate max-w-2xl mx-auto" data-id="element-196">
            If you are a volleyball coach, you've likely faced one of these
            situations:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-197">
          {problems.map((p, idx) => <div key={idx} className="bg-white rounded-lg p-7 border-t-4 border-t-pilates-blue-dark border-x border-b border-pilates-slate/10 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all relative" data-id="element-198">
              <div className="absolute top-6 right-6 text-2xl" data-id="element-199">{p.emoji}</div>
              <div className="text-pilates-lavender font-display font-bold text-lg mb-3" data-id="element-200">
                #{String(idx + 1).padStart(2, '0')}
              </div>
              <h3 className="font-display text-xl font-semibold text-pilates-blue-dark mb-2 pr-8" data-id="element-201">
                {p.title}
              </h3>
              <p className="text-pilates-slate leading-relaxed" data-id="element-202">{p.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}